/* 
Defines the Charger and its given location using coordinates, address and google query

NOTE: If new chargers are added, this needs to be manually updated
*/ 
export const chargerCoordinates = {
  "Beatty Park Leisure Centre": {
    latitude: -31.9343,
    longitude: 115.8532,
    address: "220 Vincent Street, North Perth WA",
    googleMapsQuery: "Beatty Park Leisure Centre, North Perth WA"
  },

  "Cockburn Youth Centre": {
    latitude: -32.1265,
    longitude: 115.8538,
    address: "25 Wentworth Parade, Success WA",
    googleMapsQuery: "Cockburn Youth Centre, Success WA"
  },

  "Seven West Media": {
    latitude: -31.9142,
    longitude: 115.8178,
    address: "Osborne Park, WA",
    googleMapsQuery: "Seven West Media, Osborne Park WA"
  },

  "Stockland Amberton Beach Sales Office": {
    latitude: -31.594070926530748, 
    longitude: 115.67179543027599,
    address: "Corner Marmion Avenue and, Cinnabar Dr, Eglinton WA 6034",
    googleMapsQuery: "Stockland Amberton Beach Sales and Information Centre, Eglinton WA"
  },

  "UWA-CS": {
    latitude: -31.977543,
    longitude: 115.816403,
    address: "The University of Western Australia, Crawley WA",
    googleMapsQuery: "Computer Science, University of Western Australia, Crawley WA"
  },

  "UWA EZONE North": {
    latitude: -31.979775080902467,
    longitude: 115.81566925062914,
    address: "Fairway After Clark St, Crawley WA 6009, Australia",
    googleMapsQuery: "UWA EZONE North, Crawley WA"
  },

  "UWA REV LAB": {
    latitude: -31.979253635517818,
    longitude: 115.81591608650702,
    address: "Parking lot, Fairway, Crawley WA 6009",
    googleMapsQuery: "The REV Project Charging Station, University of Western Australia"
  },

  "UWA Uni Club": {
    latitude: -31.978804,
    longitude: 115.819343,
    address: "1 Hackett Drive, Crawley WA",
    googleMapsQuery: "University Club of Western Australia"
  },

  /*
   * WEST PERTH
   * The RAC DC report and West Perth historical records appear to
   * refer to the RAC Head Office charger.
   */
  "West Perth, WA": {
    latitude: -31.947606,
    longitude: 115.849014,
    address: "832 Wellington Street, West Perth WA 6005",
    googleMapsQuery:
      "RAC Head Office, 832 Wellington Street, West Perth WA 6005"
  },

  "RAC DC Charger": {
    latitude: -31.947606,
    longitude: 115.849014,
    address: "832 Wellington Street, West Perth WA 6005",
    googleMapsQuery:
      "RAC Head Office EV Charger, 832 Wellington Street, West Perth WA 6005"
  },

  /*
   * BUNBURY
   */
  "Bunbury, WA": {
    latitude: -33.32358,
    longitude: 115.6378,
    address: "31 Symmons Street, Bunbury WA 6230",
    googleMapsQuery:
      "RAC Electric Highway, 31 Symmons Street, Bunbury WA 6230"
  },

  "Bunbury DC Charger": {
    latitude: -33.32358,
    longitude: 115.6378,
    address: "31 Symmons Street, Bunbury WA 6230",
    googleMapsQuery:
      "RAC Electric Highway, 31 Symmons Street, Bunbury WA 6230"
  },

  /*
   * BUSSELTON
   */
  "Busselton, WA": {
    latitude: -33.6466,
    longitude: 115.3339,
    address: "880 Geographe Bay Road, West Busselton WA 6280",
    googleMapsQuery:
      "RAC Electric Highway, 880 Geographe Bay Road, West Busselton WA 6280"
  },

  "Busselton DC Charger": {
    latitude: -33.6466,
    longitude: 115.3339,
    address: "880 Geographe Bay Road, West Busselton WA 6280",
    googleMapsQuery:
      "RAC Electric Highway, 880 Geographe Bay Road, West Busselton WA 6280"
  },

  /*
   * DUNSBOROUGH
   */
  "Dunsborough, WA": {
    latitude: -33.6153,
    longitude: 115.1046,
    address: "38 Dunn Bay Road, Dunsborough WA 6281",
    googleMapsQuery:
      "RAC Electric Highway, 38 Dunn Bay Road, Dunsborough WA 6281"
  },

  /*
   * DONNYBROOK
   */
  "Donnybrook, WA": {
    latitude: -33.5774,
    longitude: 115.8251,
    address: "Crowley Place, Donnybrook WA 6239",
    googleMapsQuery:
      "RAC Electric Highway, Crowley Place, Donnybrook WA 6239"
  },

  /*
   * HARVEY
   */
  "Harvey, WA": {
    latitude: -33.0808,
    longitude: 115.8916,
    address: "Hayward Street, Harvey WA 6220",
    googleMapsQuery:
      "RAC Electric Highway EV Charger, Hayward Street, Harvey WA 6220"
  },

  /*
   * MANDURAH
   */
  "Mandurah, WA": {
    latitude: -32.5277,
    longitude: 115.7216,
    address: "75 Mandurah Terrace, Mandurah WA 6210",
    googleMapsQuery:
      "RAC Electric Highway, 75 Mandurah Terrace, Mandurah WA 6210"
  },

  /*
   * MARGARET RIVER
   */
  "Margaret River, WA": {
    latitude: -33.9543,
    longitude: 115.0735,
    address: "13 Walcliffe Road, Margaret River WA 6285",
    googleMapsQuery:
      "RAC Electric Highway, 13 Walcliffe Road, Margaret River WA 6285"
  },

  "Margaret River DC Charger": {
    latitude: -33.9543,
    longitude: 115.0735,
    address: "13 Walcliffe Road, Margaret River WA 6285",
    googleMapsQuery:
      "RAC Electric Highway, 13 Walcliffe Road, Margaret River WA 6285"
  },

  /*
   * AUGUSTA
   */
  "Augusta, WA": {
    latitude: -34.3152,
    longitude: 115.1598,
    address: "72 Blackwood Avenue, Augusta WA 6290",
    googleMapsQuery:
      "RAC Electric Highway, 72 Blackwood Avenue, Augusta WA 6290"
  },

  /*
   * NANNUP
   */
  "Nannup, WA": {
    latitude: -33.9806,
    longitude: 115.7646,
    address: "16 Adam Street, Nannup WA 6275",
    googleMapsQuery:
      "RAC Electric Highway Charging Station, 16 Adam Street, Nannup WA 6275"
  },

  /*
   * Do not add "Unknown Location (dfhaDErN)" until its physical
   * location has been identified.
   */
};